export default "﻿<div class=\"TimeSlot\" data-dojo-attach-event=\"click:_onClick_TimeSlot\">\n    <div data-dojo-attach-point=\"titleNode\"></div>\n</div>\n"